import React, { useRef, useEffect } from 'react';
import './ScanPage.scss';

export default function ScanPage() {
  const videoRef  = useRef(null);
  const canvasRef = useRef(null);   // hidden — for processing only

  useEffect(() => {
    const video  = videoRef.current;
    const canvas = canvasRef.current;
    const ctx    = canvas.getContext('2d');

    (async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'user' }
        });
        video.srcObject = stream;
        await video.play();

        /* resize hidden canvas to native resolution */
        canvas.width  = video.videoWidth;
        canvas.height = video.videoHeight;

        /* optional frame loop */
        const draw = () => {
          if (video.readyState >= 2) {
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            /* run ML / processing here if needed */
          }
          requestAnimationFrame(draw);
        };
        draw();
      } catch (err) {
        console.error('Camera error:', err);
      }
    })();

    return () => {
      video.srcObject?.getTracks().forEach(t => t.stop());
    };
  }, []);

  /* video is visible – canvas stays hidden */
  return (
    <div className="scan-wrapper">
      <video ref={videoRef} muted playsInline className="video-stream" />
      <canvas ref={canvasRef} style={{ display:'none' }} />
    </div>
  );
}
